var _circle, _circle2, _circle3, _circle4, _circle5, _g, _g2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgScan(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 173,
    height: 131,
    viewBox: "0 0 173 131",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 76.5,
    cy: 58,
    r: 52,
    fill: "#E4E7EC"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 21.5,
    cy: 25,
    r: 5,
    fill: "#F2F4F7"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 18.5,
    cy: 109,
    r: 7,
    fill: "#F2F4F7"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 145.5,
    cy: 41,
    r: 7,
    fill: "#F2F4F7"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 134.5,
    cy: 14,
    r: 4,
    fill: "#F2F4F7"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#scan_svg__filter0_dd_3038_2092)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M76.5 36.063l4.536-1.9-4.535 1.932V90.19l41.795-17.515V18.557l.204-.086-.204-.09v-.091l-.104.045L76.83 0 34.5 18.031l.2.087-.2 53.899 42 18.14V36.064z",
    fill: "#F9FAFB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.5 36.063v54.095l-42-18.142.2-53.899 41.8 17.946z",
    fill: "url(#scan_svg__paint0_linear_3038_2092)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.501 36.095V90.19l41.796-17.515V18.29L76.501 36.095z",
    fill: "url(#scan_svg__paint1_linear_3038_2092)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.5 36.063l42-17.592L76.83 0 34.5 18.031l42 18.032z",
    fill: "#F2F4F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.333 11.287L92.173 29.5l.38 13.27 11.706-4.83-.354-13.354L60.827 6.817l-10.494 4.47z",
    fill: "#E4E7EC"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#scan_svg__filter1_b_3038_2092)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 52.5,
    y: 68,
    width: 48,
    height: 48,
    rx: 24,
    fill: "#344054",
    fillOpacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.5 83h-1.8c-1.12 0-1.68 0-2.108.218a2 2 0 00-.874.874c-.218.428-.218.988-.218 2.108V88m5 13h-1.8c-1.12 0-1.68 0-2.108-.218a2.003 2.003 0 01-.874-.874c-.218-.428-.218-.988-.218-2.108V96m18-8v-1.8c0-1.12 0-1.68-.218-2.108a2 2 0 00-.874-.874C83.98 83 83.42 83 82.3 83h-1.8m5 13v1.8c0 1.12 0 1.68-.218 2.108a2.003 2.003 0 01-.874.874c-.428.218-.988.218-2.108.218h-1.8m0-9a4 4 0 11-8 0 4 4 0 018 0z",
    stroke: "#fff",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "scan_svg__paint0_linear_3038_2092",
    x1: 34.5,
    y1: 72.288,
    x2: 51.087,
    y2: 27.366,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DEE1E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EFF1F5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "scan_svg__paint1_linear_3038_2092",
    x1: 76.5,
    y1: 37.154,
    x2: 123.859,
    y2: 46.583,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4E7EC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F2F4F7"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "scan_svg__filter0_dd_3038_2092",
    x: 14.5,
    y: 0,
    width: 124,
    height: 130.19,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 4,
    "in": "SourceAlpha",
    result: "effect1_dropShadow_3038_2092"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 8
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.04 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3038_2092"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 4,
    "in": "SourceAlpha",
    result: "effect2_dropShadow_3038_2092"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 20
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 12
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "effect1_dropShadow_3038_2092",
    result: "effect2_dropShadow_3038_2092"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect2_dropShadow_3038_2092",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "scan_svg__filter1_b_3038_2092",
    x: 44.5,
    y: 60,
    width: 64,
    height: 64,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    "in": "BackgroundImageFix",
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_3038_2092"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_backgroundBlur_3038_2092",
    result: "shape"
  })))));
}
export default SvgScan;